// @ts-nocheck
/* ═══ AR — recunoașterea utilajelor cu modelul LOCAL + învățarea lui (30 sep 2026) ══════════════
 *
 * Dan: „îl punem doar pe model AI local și trebuie învățat. Facem filmări și poze cu liniile pe rând…
 * o secțiune în care să încărcăm poze sau filmări până când modelul are toată linia de jur împrejur;
 * în meniul de încărcare poze la linii să fie ca o bară de progres. Scopul final: cu ochelarii, în
 * direcția în care te uiți, să-ți apară informațiile despre utilaj.”
 *
 * Două file:
 *   · Recunoaștere — camera; la 2 s un cadru merge la /api/ar/identify (model local, fără cloud).
 *     „Da, e acesta” / „Nu, e altul” adaugă cadrul la învățare.
 *   · Învățare — pe linie și pe utilaj: câte cadre clare are fiecare latură (față, spate, stânga,
 *     dreapta — ținta 40 pe latură), bare de progres, încărcare poze/filmări cu bară de încărcare,
 *     antrenarea modelului și cât de bine recunoaște fiecare utilaj.
 *
 * Înainte: ecranul trimitea la 7 s o poză în cascadă până la Claude (neplafonat, nenumărat), pleca fără
 * Content-Type (415 la fiecare cerere), folosea id-uri deja luate de secțiunea Piese (camera neagră) și
 * nu oprea camera la ieșire.
 */
import { state, api, escHtml, toast } from './core';

const INTERVAL_RECUNOASTERE_MS = 2000;
let _flux: MediaStream | null = null;
let _timer: ReturnType<typeof setInterval> | null = null;
let _ocupat = false;
let _sesiune = 'ar-' + Math.random().toString(36).slice(2, 10);
let _ultim: any = null;
let _fila: 'recunoastere' | 'invatare' = 'recunoastere';
let _progres: any = null;
let _deschise = new Set<string>();
let _poll: ReturnType<typeof setTimeout> | null = null;

const _inginer = () => ['engineer', 'master'].includes(state.currentUser?.role || '');
const _json = (body: any) => ({ method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });

export function loadArView(): void {
    const sec = document.getElementById('sec-ar');
    if (!sec) return;
    sec.innerHTML = `
    <div class="ari">
        <div class="ari-file" role="tablist">
            <button type="button" class="ari-fila" data-arfila="recunoastere" role="tab">Recunoaștere</button>
            <button type="button" class="ari-fila" data-arfila="invatare" role="tab">Învățare</button>
        </div>
        <div id="ari-recunoastere" class="ari-panou"></div>
        <div id="ari-invatare" class="ari-panou" hidden></div>
    </div>`;
    sec.querySelectorAll('.ari-fila').forEach(b => b.addEventListener('click', () => _arataFila((b as HTMLElement).dataset.arfila as any)));
    _arataFila(_fila);
}

export function destroyArView(): void {
    _oprescCamera();
    if (_poll) { clearTimeout(_poll); _poll = null; }
}

function _arataFila(f: 'recunoastere' | 'invatare'): void {
    _fila = f;
    document.querySelectorAll('#sec-ar .ari-fila').forEach(b => {
        const activ = (b as HTMLElement).dataset.arfila === f;
        b.classList.toggle('activ', activ);
        b.setAttribute('aria-selected', activ ? 'true' : 'false');
    });
    const r = document.getElementById('ari-recunoastere'), i = document.getElementById('ari-invatare');
    if (r) r.hidden = f !== 'recunoastere';
    if (i) i.hidden = f !== 'invatare';
    if (f === 'recunoastere') { _construiesteRecunoastere(); void _pornescCamera(); }
    else { _oprescCamera(); void _incarcaProgres(); }
}

/* ─── Recunoaștere ─────────────────────────────────────────────────────── */

function _construiesteRecunoastere(): void {
    const el = document.getElementById('ari-recunoastere');
    if (!el || el.dataset.gata) return;
    el.dataset.gata = '1';
    el.innerHTML = `
    <div class="ar-container ari-cam">
        <div class="ar-camera-area">
            <video id="ar-cam-video" autoplay playsinline muted></video>
            <canvas id="ar-cam-canvas" hidden></canvas>
            <div class="ar-hud-top">
                <div class="ar-status-indicator"><span class="ar-status-dot"></span><span id="ar-cam-stare">Se pornește camera…</span></div>
            </div>
            <div class="ar-overlay-panel" id="ar-cam-info" hidden></div>
            <div class="ar-no-camera" id="ar-cam-fara" hidden>
                <h3>Camera nu este disponibilă</h3>
                <p>Fotografiază utilajul și încarcă poza.</p>
                <label class="ar-upload-btn ar-upload-primary">Încarcă o poză
                    <input type="file" accept="image/*" capture="environment" id="ar-cam-fisier" hidden></label>
            </div>
        </div>
    </div>`;
    (document.getElementById('ar-cam-fisier') as HTMLInputElement)?.addEventListener('change', ev => {
        const f = (ev.target as HTMLInputElement).files?.[0];
        if (f) _uploadPhotoFile(f);
    });
}

async function _pornescCamera(): Promise<void> {
    const video = document.getElementById('ar-cam-video') as HTMLVideoElement | null;
    const stare = document.getElementById('ar-cam-stare');
    if (!video) return;
    if (_flux) return;
    try {
        _flux = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment', width: { ideal: 1280 } }, audio: false });
        video.srcObject = _flux;
        if (stare) stare.textContent = 'Îndreaptă camera spre un utilaj';
        _timer = setInterval(_recunoaste, INTERVAL_RECUNOASTERE_MS);
    } catch (_e) {
        document.getElementById('ar-cam-fara')!.hidden = false;
        video.hidden = true;
        if (stare) stare.textContent = 'Fără cameră';
    }
}

function _oprescCamera(): void {
    if (_timer) { clearInterval(_timer); _timer = null; }
    if (_flux) { _flux.getTracks().forEach(t => t.stop()); _flux = null; }
    const v = document.getElementById('ar-cam-video') as HTMLVideoElement | null;
    if (v) v.srcObject = null;
}

function _cadruCurent(): string | null {
    const v = document.getElementById('ar-cam-video') as HTMLVideoElement | null;
    const c = document.getElementById('ar-cam-canvas') as HTMLCanvasElement | null;
    if (!v || !c || !v.videoWidth) return null;
    const s = Math.min(1, 640 / Math.max(v.videoWidth, v.videoHeight));
    c.width = Math.round(v.videoWidth * s); c.height = Math.round(v.videoHeight * s);
    c.getContext('2d')!.drawImage(v, 0, 0, c.width, c.height);
    return c.toDataURL('image/jpeg', 0.8);
}

async function _recunoaste(dataUrl?: string): Promise<void> {
    if (_ocupat || document.hidden || _fila !== 'recunoastere') return;
    const img = dataUrl || _cadruCurent();
    if (!img) return;
    _ocupat = true;
    try {
        const r = await api('/api/ar/identify', _json({ image: img, session_id: _sesiune }));
        _afiseaza(r);
    } catch (_e) {
        const s = document.getElementById('ar-cam-stare');
        if (s) s.textContent = 'Serverul nu răspunde';
    } finally { _ocupat = false; }
}

function _afiseaza(r: any): void {
    const stare = document.getElementById('ar-cam-stare');
    const info = document.getElementById('ar-cam-info');
    if (!info) return;
    if (!r || r.necunoscut) {
        if (stare) stare.textContent = r?.motiv === 'model_neantrenat'
            ? 'Modelul nu e încă învățat — vezi fila „Învățare”'
            : 'Nu recunosc încă ce e în cadru';
        info.hidden = true;
        _ultim = null;
        return;
    }
    _ultim = r;
    if (stare) stare.textContent = 'Recunoscut: ' + (r.machine_name || r.machine_id);
    const lucrari = (r.next_maintenance || []).map((m: any) => `<li>${escHtml(m.action || '')}<small> · ${escHtml(m.interval || '')}</small></li>`).join('');
    info.innerHTML = `
        <div class="ar-machine-header">
            <div class="ar-machine-info"><h3>${escHtml(r.machine_name || r.machine_id)}</h3>
                <span class="ar-subtitle">${escHtml(r.production_line ? 'Linia ' + r.production_line : '')}${r.product ? ' · ' + escHtml(r.product) : ''}</span></div>
            <div class="ar-confidence">${Math.round((r.incredere || 0) * 100)}%</div>
        </div>
        <div class="ar-data-grid">
            <div class="ar-data-item"><span class="ar-data-label">Stare</span><span class="ar-data-value">${escHtml(r.status || '—')}</span></div>
            <div class="ar-data-item"><span class="ar-data-label">Ore funcționare</span><span class="ar-data-value">${r.operating_hours != null ? Math.round(r.operating_hours) : '—'}</span></div>
            <div class="ar-data-item"><span class="ar-data-label">Fișe de reglaj</span><span class="ar-data-value">${r.fise_reglaj || 0}</span></div>
        </div>
        ${lucrari ? `<div class="ar-maintenance-section"><b>Următoarele lucrări</b><ul>${lucrari}</ul></div>` : ''}
        <div class="ar-actions">
            <button type="button" class="ar-action-btn ar-btn-confirm" data-arac="da">Da, e acesta</button>
            <button type="button" class="ar-action-btn ar-btn-correct" data-arac="nu">Nu, e altul</button>
            <button type="button" class="ar-action-btn ar-btn-detail" data-arac="panou">Deschide utilajul</button>
        </div>`;
    info.hidden = false;
    info.querySelectorAll('[data-arac]').forEach(b => b.addEventListener('click', () => {
        const a = (b as HTMLElement).dataset.arac;
        if (a === 'da') void _arConfirmIdentification();
        else if (a === 'nu') void _arCorrectIdentification();
        else _arOpenDetail();
    }));
}

export async function _arConfirmIdentification(): Promise<void> {
    if (!_ultim?.machine_id) return;
    try {
        await api('/api/ar/confirmare', _json({ session_id: _sesiune, machine_id: _ultim.machine_id }));
        toast('Mulțumesc — cadrul intră la învățare', 'success');
    } catch (e: any) { toast('Nu s-a salvat: ' + (e?.message || e), 'error'); }
}

export async function _arCorrectIdentification(): Promise<void> {
    const ales = await _alegeUtilaj();
    if (!ales) return;
    try {
        await api('/api/ar/confirmare', _json({ session_id: _sesiune, machine_id: ales }));
        toast('Corectat — cadrul intră la învățare cu utilajul ales', 'success');
    } catch (e: any) { toast('Nu s-a salvat: ' + (e?.message || e), 'error'); }
}

/** Alegerea utilajului corect: listă pe linii (toate utilajele, fără matrițe). */
async function _alegeUtilaj(): Promise<string | null> {
    const lista = await api('/api/machines/all').catch(() => []);
    const pe: Record<string, any[]> = {};
    (lista || []).filter((m: any) => m.machine_type !== 'mold').forEach((m: any) => {
        const l = String(m.line || '—').split(',')[0].trim() || '—';
        (pe[l] = pe[l] || []).push(m);
    });
    const opt = Object.keys(pe).sort().map(l => `<optgroup label="Linia ${escHtml(l)}">${pe[l].map((m: any) =>
        `<option value="${escHtml(m.id)}">${escHtml(m.display_name || m.name || m.id)}</option>`).join('')}</optgroup>`).join('');
    return new Promise(res => {
        const ov = document.createElement('div');
        ov.className = 'proc-overlay';
        ov.innerHTML = `<div class="proc-container" style="max-width:460px" role="dialog" aria-modal="true">
            <div class="proc-header"><div class="proc-header-top"><h2 class="proc-title">Ce utilaj e în cadru?</h2>
            <button type="button" class="proc-close" aria-label="Închide">&times;</button></div></div>
            <div style="padding:16px;display:flex;flex-direction:column;gap:12px">
                <select class="dx-input" id="ar-alege-utilaj" style="min-height:44px">${opt}</select>
                <div style="display:flex;gap:10px;justify-content:flex-end">
                    <button type="button" class="btn" data-r="nu">Renunță</button>
                    <button type="button" class="btn btn-primary" data-r="da">E acesta</button></div></div></div>`;
        document.body.appendChild(ov);
        const gata = (v: string | null) => { ov.remove(); res(v); };
        ov.querySelector('.proc-close')!.addEventListener('click', () => gata(null));
        ov.querySelector('[data-r="nu"]')!.addEventListener('click', () => gata(null));
        ov.querySelector('[data-r="da"]')!.addEventListener('click', () =>
            gata((ov.querySelector('#ar-alege-utilaj') as HTMLSelectElement).value || null));
    });
}

export function _arOpenDetail(): void {
    if (_ultim?.machine_id && (window as any).openMachinePanel) (window as any).openMachinePanel(_ultim.machine_id);
}

export function _arStartMaintenance(): void { _arOpenDetail(); }
export function _arIdentifyPart(): void { (window as any).showSection?.('sec-parts'); }
export function _arToggleTraining(): void { _arataFila(_fila === 'invatare' ? 'recunoastere' : 'invatare'); }
export function _arStartYoloTraining(): void { void _antreneaza(); }

export function _arUploadPhoto(input: HTMLInputElement): void {
    const f = input?.files?.[0];
    if (f) _uploadPhotoFile(f);
}

function _uploadPhotoFile(f: File): void {
    const rd = new FileReader();
    rd.onload = () => { void _recunoaste(String(rd.result)); };
    rd.readAsDataURL(f);
}

/* ─── Învățare ─────────────────────────────────────────────────────────── */

const _bara = (p: number, mic = false) =>
    `<div class="ari-bara${mic ? ' ari-bara-mica' : ''}" role="progressbar" aria-valuenow="${p}" aria-valuemin="0" aria-valuemax="100">
        <div class="ari-bara-plin${p >= 100 ? ' ari-gata' : ''}" style="width:${Math.max(0, Math.min(100, p))}%"></div></div>`;

async function _incarcaProgres(): Promise<void> {
    const el = document.getElementById('ari-invatare');
    if (!el) return;
    if (!_progres) el.innerHTML = '<div class="alarm-empty">Se încarcă…</div>';
    try {
        _progres = await api('/api/ar/invatare/progres');
    } catch (e: any) {
        el.innerHTML = `<div class="alarm-empty">Nu s-a putut încărca: ${escHtml(e?.message || String(e))}</div>`;
        return;
    }
    _randeazaInvatare();
    const inLucru = (_progres.linii || []).some((l: any) => l.utilaje.some((u: any) => u.in_lucru > 0))
        || _progres.ultima_antrenare?.status === 'running';
    if (_poll) clearTimeout(_poll);
    if (inLucru && _fila === 'invatare') _poll = setTimeout(() => void _incarcaProgres(), 3000);
}

function _randeazaInvatare(): void {
    const el = document.getElementById('ari-invatare');
    if (!el || !_progres) return;
    const t = _progres.tinta_pe_latura || 40;
    const m = _progres.model;
    const rul = _progres.ultima_antrenare;
    const eticheta: Record<string, string> = {};
    (_progres.laturi || []).forEach((l: any) => { eticheta[l.cod] = l.eticheta; });
    const stareModel = m
        ? `Model învățat pe ${m.utilaje} utilaje, ${m.cadre} cadre${m.acuratete_medie != null ? ` · recunoaște corect ${Math.round(m.acuratete_medie * 100)}% la probă` : ''}`
        : 'Modelul nu e încă învățat.';
    const stareRulare = rul?.status === 'running' ? ' · se antrenează acum…'
        : rul?.status === 'failed' ? ` · ultima antrenare a eșuat: ${escHtml(String(rul.notes || '').slice(0, 160))}` : '';
    let html = `
    <div class="ari-antet">
        <div>
            <div class="ari-titlu">Învățarea modelului local</div>
            <div class="ari-sub">${escHtml(stareModel)}${stareRulare}</div>
            <div class="ari-sub">Filmează încet fiecare latură a utilajului, 20–40 de secunde, de la 2–4 m, cu tot utilajul în cadru.
                Apoi câteva poze de aproape la „Detalii”. Ținta: ${t} cadre clare pe latură.</div>
        </div>
        ${_inginer() ? `<button type="button" class="btn btn-primary ari-antreneaza" ${rul?.status === 'running' ? 'disabled' : ''}>Antrenează modelul</button>` : ''}
    </div>`;
    for (const l of _progres.linii || []) {
        const deschis = _deschise.has('L:' + l.id);
        html += `<div class="ari-linie${deschis ? ' deschis' : ''}">
            <button type="button" class="ari-linie-cap" data-arlinie="${escHtml(l.id)}" aria-expanded="${deschis}">
                <span class="ari-linie-nume">${escHtml(l.id === l.nume ? 'Linia ' + l.id : l.nume)}</span>
                <span class="ari-linie-proc">${l.procent}%</span>
                ${_bara(l.procent)}
            </button>`;
        if (deschis) {
            html += '<div class="ari-utilaje">';
            for (const u of l.utilaje) {
                const ud = _deschise.has('U:' + u.id);
                html += `<div class="ari-utilaj" data-arut="${escHtml(u.id)}">
                    <button type="button" class="ari-utilaj-cap" data-arutcap="${escHtml(u.id)}" aria-expanded="${ud}">
                        <span class="ari-utilaj-nume">${escHtml(u.nume)}</span>
                        ${u.acuratete != null ? `<span class="ari-acur${u.acuratete >= 0.9 ? ' bun' : u.acuratete >= 0.7 ? ' mediu' : ' slab'}">recunoaște ${Math.round(u.acuratete * 100)}%</span>` : ''}
                        ${u.in_lucru ? '<span class="ari-lucru">se procesează…</span>' : ''}
                        <span class="ari-linie-proc">${u.procent}%</span>
                        ${_bara(u.procent, true)}
                    </button>`;
                if (ud) {
                    html += '<div class="ari-laturi">';
                    for (const lat of ['fata', 'spate', 'stanga', 'dreapta', 'detaliu']) {
                        const n = u.laturi[lat] || 0;
                        const p = lat === 'detaliu' ? Math.min(100, n * 10) : Math.round(Math.min(n, t) * 100 / t);
                        html += `<div class="ari-latura">
                            <div class="ari-latura-cap"><b>${escHtml(eticheta[lat] || lat)}</b>
                                <span>${n}${lat === 'detaliu' ? '' : ' / ' + t} cadre</span></div>
                            ${_bara(p, true)}
                            <div class="ari-latura-btn">
                                <label class="btn btn-sm">Filmează<input type="file" accept="video/*" capture="environment" hidden data-arinc="${escHtml(u.id)}|${lat}"></label>
                                <label class="btn btn-sm">Fotografiază<input type="file" accept="image/*" capture="environment" hidden data-arinc="${escHtml(u.id)}|${lat}"></label>
                                <label class="btn btn-sm">Din galerie<input type="file" accept="image/*,video/*" multiple hidden data-arinc="${escHtml(u.id)}|${lat}"></label>
                            </div>
                            <div class="ari-incarcare" id="ari-inc-${escHtml(u.id)}-${lat}" hidden></div>
                        </div>`;
                    }
                    html += `</div>
                        <button type="button" class="btn btn-sm ari-media-btn" data-armedia="${escHtml(u.id)}">Ce am încărcat</button>
                        <div class="ari-media" id="ari-media-${escHtml(u.id)}" hidden></div>`;
                }
                html += '</div>';
            }
            html += '</div>';
        }
        html += '</div>';
    }
    el.innerHTML = html;
    el.querySelector('.ari-antreneaza')?.addEventListener('click', () => void _antreneaza());
    el.querySelectorAll('[data-arlinie]').forEach(b => b.addEventListener('click', () => {
        const k = 'L:' + (b as HTMLElement).dataset.arlinie;
        _deschise.has(k) ? _deschise.delete(k) : _deschise.add(k);
        _randeazaInvatare();
    }));
    el.querySelectorAll('[data-arutcap]').forEach(b => b.addEventListener('click', () => {
        const k = 'U:' + (b as HTMLElement).dataset.arutcap;
        _deschise.has(k) ? _deschise.delete(k) : _deschise.add(k);
        _randeazaInvatare();
    }));
    el.querySelectorAll('input[data-arinc]').forEach(inp => inp.addEventListener('change', () => {
        const [mid, lat] = String((inp as HTMLElement).dataset.arinc).split('|');
        const f = (inp as HTMLInputElement).files;
        if (f && f.length) _incarca(mid, lat, Array.from(f));
    }));
    el.querySelectorAll('[data-armedia]').forEach(b => b.addEventListener('click', () => void _arataMedia((b as HTMLElement).dataset.armedia!)));
}

function _incarca(machineId: string, latura: string, fisiere: File[]): void {
    const box = document.getElementById(`ari-inc-${machineId}-${latura}`);
    const fd = new FormData();
    fd.append('machine_id', machineId);
    fd.append('latura', latura);
    fisiere.forEach(f => fd.append('fisiere', f));
    const total = fisiere.reduce((s, f) => s + f.size, 0);
    if (box) { box.hidden = false; box.innerHTML = `Se încarcă ${fisiere.length} ${fisiere.length === 1 ? 'fișier' : 'fișiere'} (${(total / 1048576).toFixed(1)} MB)… ${_bara(0, true)}`; }
    const xhr = new XMLHttpRequest();
    xhr.open('POST', '/api/ar/invatare/incarca');
    xhr.withCredentials = true;
    xhr.upload.onprogress = ev => {
        if (!box || !ev.lengthComputable) return;
        const p = Math.round(ev.loaded * 100 / ev.total);
        box.innerHTML = `Se încarcă… ${p}% ${_bara(p, true)}`;
    };
    xhr.onload = () => {
        let r: any = {};
        try { r = JSON.parse(xhr.responseText || '{}'); } catch (_e) { /* */ }
        if (xhr.status >= 200 && xhr.status < 300) {
            if (box) box.innerHTML = 'Încărcat — se extrag cadrele clare…';
            toast('Încărcat. Cadrele se extrag în câteva secunde.', 'success');
            setTimeout(() => void _incarcaProgres(), 1500);
        } else {
            const msg = xhr.status === 413 ? 'Fișierul e prea mare (maxim 200 MB) — filmează mai scurt.' : (r.error || ('Eroare ' + xhr.status));
            if (box) box.innerHTML = `<span class="ari-eroare">${escHtml(msg)}</span>`;
            toast(msg, 'error');
        }
    };
    xhr.onerror = () => { if (box) box.innerHTML = '<span class="ari-eroare">Conexiunea s-a întrerupt — încearcă din nou.</span>'; };
    xhr.send(fd);
}

async function _arataMedia(machineId: string): Promise<void> {
    const box = document.getElementById('ari-media-' + machineId);
    if (!box) return;
    if (!box.hidden) { box.hidden = true; return; }
    box.hidden = false;
    box.innerHTML = 'Se încarcă…';
    try {
        const r = await api('/api/ar/invatare/media?machine_id=' + encodeURIComponent(machineId));
        const lista = r.media || [];
        if (!lista.length) { box.innerHTML = '<div class="ari-sub">Nimic încărcat încă.</div>'; return; }
        const et: Record<string, string> = {};
        ((_progres && _progres.laturi) || []).forEach((l: any) => { et[l.cod] = l.eticheta; });
        box.innerHTML = lista.map((m: any) => `<div class="ari-media-rand">
            ${m.miniatura ? `<img src="${escHtml(m.miniatura)}" alt="" loading="lazy">` : '<span class="ari-fara-poza"></span>'}
            <div><b>${m.tip === 'filmare' ? 'Filmare' : m.tip === 'confirmare' ? 'Confirmat din cameră' : 'Poză'}</b> · ${escHtml(et[m.latura] || m.latura)}
                <div class="ari-sub">${m.stare === 'gata' ? `${m.cadre_pastrate} din ${m.cadre_total} cadre clare` : m.stare === 'eroare' ? 'eroare: ' + escHtml(m.eroare || '') : 'se procesează…'} · ${escHtml(m.incarcat_de || '')} · ${escHtml(String(m.incarcat_la || '').slice(0, 16))}</div></div>
            <button type="button" class="btn btn-sm" data-arexcl="${m.id}" title="Încărcat la utilajul greșit sau neclar">Scoate</button>
        </div>`).join('');
        box.querySelectorAll('[data-arexcl]').forEach(b => b.addEventListener('click', async () => {
            try {
                await api(`/api/ar/invatare/media/${(b as HTMLElement).dataset.arexcl}/exclude`, _json({}));
                (b.closest('.ari-media-rand') as HTMLElement)?.remove();
                void _incarcaProgres();
            } catch (e: any) { toast('Eroare: ' + (e?.message || e), 'error'); }
        }));
    } catch (e: any) { box.innerHTML = 'Eroare: ' + escHtml(e?.message || String(e)); }
}

async function _antreneaza(): Promise<void> {
    try {
        const r = await api('/api/ar/training/start', _json({}));
        toast(r.message || 'Antrenarea a pornit', 'success');
        void _incarcaProgres();
    } catch (e: any) { toast(e?.message || String(e), 'error'); }
}
